import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=a2dbd9a6&scoped=true"
import script from "./Labels.vue?vue&type=script&lang=ts"
export * from "./Labels.vue?vue&type=script&lang=ts"
import style0 from "./Labels.vue?vue&type=style&index=0&id=a2dbd9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dbd9a6",
  null
  
)

export default component.exports